export const OPEN_IN_EMBED_ENABLED = 'web.stream.openInEmbed.enabled';
export const OPEN_IN_EMBED_DIALOG_FREQUENCY = 'web.stream.openInEmbed.dialog.frequency.inDays';
